import AppWrapper from "../../components/cm/AppWrapper";
import SideBarMain from "../../components/cm/SideBarMain/SideBar";
import Container from "../../components/modules/FollowUps/followup-form/modules/DetailBase/Container";
import DynamicSection from "../../components/modules/FollowUps/followup-form/modules/DynamicSection";

const Template = () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <Container>
        <DynamicSection />
      </Container>
    </AppWrapper.WithSidebar>
  );
};

export default Template;
